import styled from "styled-components";

const S = {
    MenuWrapper: styled.div`
        width: 100%;
        float: left;
        padding: 25px;
        position: relative;
        z-index: 10;
        box-sizing: border-box;
        background: #f2f5f4;
        border-radius: 8px 8px 0px 0px;
        -webkit-box-shadow: 0px 3px 6px -2px rgba(0,0,0,0.10);
        -moz-box-shadow: 0px 3px 6px -2px rgba(0,0,0,0.10);
        box-shadow: 0px 3px 6px -2px rgba(0,0,0,0.10);
    `,
    Logo: styled.div`
        float: left;
        width: 80px;//80di eskiden
        height: 50px;
        img{
            width: 100%;
            height: 100%;
        }
    `,
    Menu: styled.ul`
        width: auto;
        float: right;
        margin:0px;
        li{
            margin: 12px 12px 12px 12px;
            a,.cikis{
                text-decoration: none;
                font-weight: 600;
                font-size:17px;
                color:#b8bdbb;
                text-shadow: 0px 0px 28px rgba(150, 150, 150, 0.20);
                transition: 500ms;
                cursor: pointer;
            &:hover{
                color:#19B5FE;
                transition: 500ms;
            }
            &:active{
                color:#19B5FE;
                transition: 500ms;
            }
            &:focus{
                color:#19B5FE;
                transition: 500ms;
            }
            }
        }
    `
}

export default S